/**
 * Prime Container — Shared Pricing Calculator Core
 * ================================================
 * This file contains all pricing logic, depot data, and Google Maps integration.
 * It is shared by all three Shopify sections (homepage hero, product page, collection page).
 *
 * To update pricing: edit PRODUCT_PRICES, DEPOTS, and PRODUCT_MARGINS below.
 * To add a new product: add its key to PRODUCT_PRICES for each depot and to PRODUCT_MARGINS.
 *
 * INSTALLATION: Upload this file to Assets in your Shopify theme.
 * Then reference it in sections with: {{ 'prime-calc-core.js' | asset_url | script_tag }}
 */

window.PrimeCalc = (function () {
  'use strict';

  // ============================================================
  // CONFIG — Update these when your costs/inventory change
  // ============================================================

  var MAPS_API_KEY = 'AIzaSyCICD1KtR4fc3BhHPBArs6chYy4vTBRwKw';

  // Wholesale cost (weighted avg) by depot × product key
  // null = not available at this depot
  var PRODUCT_PRICES = {
    "Los Angeles, CA":    { '20ft-one-trip': 1858, '20ft-open-side': 4750, '20ft-side-door': 2993, '20ft-used': 1100, '40ft-hc-one-trip': 3070, '40ft-hc-double-door': null, '40ft-hc-open-side': null, '40ft-hc-side-door': 6030, '40ft-hc-used': 1550, '40ft-std-used': 1450 },
    "Oakland, CA":        { '20ft-one-trip': 2097, '20ft-open-side': null, '20ft-side-door': null, '20ft-used': 1450, '40ft-hc-one-trip': 3070, '40ft-hc-double-door': null, '40ft-hc-open-side': null, '40ft-hc-side-door': null, '40ft-hc-used': null, '40ft-std-used': null },
    "Seattle/Tacoma":     { '20ft-one-trip': 2492, '20ft-open-side': null, '20ft-side-door': null, '20ft-used': 1500, '40ft-hc-one-trip': 2912, '40ft-hc-double-door': null, '40ft-hc-open-side': null, '40ft-hc-side-door': 6253, '40ft-hc-used': 1906, '40ft-std-used': 1616 },
    "Portland, OR":       { '20ft-one-trip': 2550, '20ft-open-side': null, '20ft-side-door': null, '20ft-used': null, '40ft-hc-one-trip': 3400, '40ft-hc-double-door': null, '40ft-hc-open-side': null, '40ft-hc-side-door': 5600, '40ft-hc-used': null, '40ft-std-used': null },
    "Phoenix, AZ":        { '20ft-one-trip': null, '20ft-open-side': 5950, '20ft-side-door': null, '20ft-used': null, '40ft-hc-one-trip': 3800, '40ft-hc-double-door': null, '40ft-hc-open-side': null, '40ft-hc-side-door': 11400, '40ft-hc-used': null, '40ft-std-used': null },
    "El Paso, TX":        { '20ft-one-trip': 2800, '20ft-open-side': 4723, '20ft-side-door': null, '20ft-used': null, '40ft-hc-one-trip': 2818, '40ft-hc-double-door': 3900, '40ft-hc-open-side': 10000, '40ft-hc-side-door': 6050, '40ft-hc-used': 1950, '40ft-std-used': null },
    "San Antonio, TX":    { '20ft-one-trip': 2550, '20ft-open-side': null, '20ft-side-door': null, '20ft-used': null, '40ft-hc-one-trip': null, '40ft-hc-double-door': null, '40ft-hc-open-side': null, '40ft-hc-side-door': null, '40ft-hc-used': null, '40ft-std-used': null },
    "Denver, CO":         { '20ft-one-trip': 2996, '20ft-open-side': 5487, '20ft-side-door': null, '20ft-used': 2050, '40ft-hc-one-trip': 3422, '40ft-hc-double-door': 4297, '40ft-hc-open-side': null, '40ft-hc-side-door': 7150, '40ft-hc-used': 2405, '40ft-std-used': 2400 },
    "Salt Lake City, UT": { '20ft-one-trip': 2744, '20ft-open-side': 5666, '20ft-side-door': 4061, '20ft-used': 1900, '40ft-hc-one-trip': 3514, '40ft-hc-double-door': 4435, '40ft-hc-open-side': null, '40ft-hc-side-door': 7475, '40ft-hc-used': 2461, '40ft-std-used': 2350 },
    "Kansas City, MO":    { '20ft-one-trip': 1979, '20ft-open-side': 4537, '20ft-side-door': null, '20ft-used': 1306, '40ft-hc-one-trip': 2633, '40ft-hc-double-door': 3321, '40ft-hc-open-side': null, '40ft-hc-side-door': 5683, '40ft-hc-used': 1606, '40ft-std-used': 1587 },
    "Saint Louis, MO":    { '20ft-one-trip': 1797, '20ft-open-side': 4116, '20ft-side-door': 5650, '20ft-used': 1210, '40ft-hc-one-trip': 2777, '40ft-hc-double-door': 3360, '40ft-hc-open-side': null, '40ft-hc-side-door': 5726, '40ft-hc-used': 1605, '40ft-std-used': 1725 },
    "Chicago, IL":        { '20ft-one-trip': 1618, '20ft-open-side': 4625, '20ft-side-door': 2663, '20ft-used': 749, '40ft-hc-one-trip': 2563, '40ft-hc-double-door': 3197, '40ft-hc-open-side': null, '40ft-hc-side-door': 5087, '40ft-hc-used': 1803, '40ft-std-used': 1000 },
    "Minneapolis, MN":    { '20ft-one-trip': 2326, '20ft-open-side': 5200, '20ft-side-door': null, '20ft-used': 1450, '40ft-hc-one-trip': 2958, '40ft-hc-double-door': 3606, '40ft-hc-open-side': null, '40ft-hc-side-door': 6295, '40ft-hc-used': 2000, '40ft-std-used': 1650 },
    "Indianapolis, IN":   { '20ft-one-trip': 1811, '20ft-open-side': null, '20ft-side-door': null, '20ft-used': 1350, '40ft-hc-one-trip': 3187, '40ft-hc-double-door': 3450, '40ft-hc-open-side': null, '40ft-hc-side-door': null, '40ft-hc-used': 1766, '40ft-std-used': 1750 },
    "Omaha, NE":          { '20ft-one-trip': 2287, '20ft-open-side': 5000, '20ft-side-door': null, '20ft-used': 1450, '40ft-hc-one-trip': 2900, '40ft-hc-double-door': 3542, '40ft-hc-open-side': 10000, '40ft-hc-side-door': 6168, '40ft-hc-used': 2033, '40ft-std-used': null },
    "Dallas, TX":         { '20ft-one-trip': 1989, '20ft-open-side': 4159, '20ft-side-door': null, '20ft-used': 1321, '40ft-hc-one-trip': 2872, '40ft-hc-double-door': 3478, '40ft-hc-open-side': null, '40ft-hc-side-door': 5427, '40ft-hc-used': 1652, '40ft-std-used': 1550 },
    "Houston, TX":        { '20ft-one-trip': 1652, '20ft-open-side': 3713, '20ft-side-door': 2453, '20ft-used': 850, '40ft-hc-one-trip': 2660, '40ft-hc-double-door': 3422, '40ft-hc-open-side': null, '40ft-hc-side-door': 4866, '40ft-hc-used': 1530, '40ft-std-used': 1350 },
    "New Orleans, LA":    { '20ft-one-trip': 1880, '20ft-open-side': 4182, '20ft-side-door': 3700, '20ft-used': 1050, '40ft-hc-one-trip': 3300, '40ft-hc-double-door': null, '40ft-hc-open-side': null, '40ft-hc-side-door': 6125, '40ft-hc-used': 2250, '40ft-std-used': 1750 },
    "Mobile, AL":         { '20ft-one-trip': 1952, '20ft-open-side': null, '20ft-side-door': 3250, '20ft-used': 1238, '40ft-hc-one-trip': 3097, '40ft-hc-double-door': null, '40ft-hc-open-side': null, '40ft-hc-side-door': null, '40ft-hc-used': 1650, '40ft-std-used': null },
    "Memphis, TN":        { '20ft-one-trip': 1811, '20ft-open-side': 4450, '20ft-side-door': 2710, '20ft-used': 1055, '40ft-hc-one-trip': 2661, '40ft-hc-double-door': 3197, '40ft-hc-open-side': 9400, '40ft-hc-side-door': 5676, '40ft-hc-used': 1316, '40ft-std-used': 1314 },
    "Nashville, TN":      { '20ft-one-trip': 2189, '20ft-open-side': null, '20ft-side-door': null, '20ft-used': 1332, '40ft-hc-one-trip': 3010, '40ft-hc-double-door': 3800, '40ft-hc-open-side': null, '40ft-hc-side-door': 6350, '40ft-hc-used': 1750, '40ft-std-used': null },
    "Atlanta, GA":        { '20ft-one-trip': 2100, '20ft-open-side': 6150, '20ft-side-door': null, '20ft-used': null, '40ft-hc-one-trip': 3260, '40ft-hc-double-door': 3550, '40ft-hc-open-side': null, '40ft-hc-side-door': 5362, '40ft-hc-used': 1575, '40ft-std-used': 1600 },
    "Louisville, KY":     { '20ft-one-trip': 2100, '20ft-open-side': null, '20ft-side-door': null, '20ft-used': null, '40ft-hc-one-trip': 2773, '40ft-hc-double-door': 3391, '40ft-hc-open-side': null, '40ft-hc-side-door': 5675, '40ft-hc-used': 2370, '40ft-std-used': null },
    "Cincinnati, OH":     { '20ft-one-trip': 1810, '20ft-open-side': 4000, '20ft-side-door': null, '20ft-used': 1366, '40ft-hc-one-trip': 2570, '40ft-hc-double-door': 3375, '40ft-hc-open-side': null, '40ft-hc-side-door': 6325, '40ft-hc-used': 1589, '40ft-std-used': 1550 },
    "Columbus, OH":       { '20ft-one-trip': 1888, '20ft-open-side': 3900, '20ft-side-door': null, '20ft-used': 1269, '40ft-hc-one-trip': 2850, '40ft-hc-double-door': 3268, '40ft-hc-open-side': null, '40ft-hc-side-door': 6650, '40ft-hc-used': 1450, '40ft-std-used': null },
    "Cleveland, OH":      { '20ft-one-trip': 1846, '20ft-open-side': 3853, '20ft-side-door': null, '20ft-used': 1056, '40ft-hc-one-trip': 2850, '40ft-hc-double-door': 3204, '40ft-hc-open-side': null, '40ft-hc-side-door': 6362, '40ft-hc-used': 1983, '40ft-std-used': null },
    "Detroit, MI":        { '20ft-one-trip': 1748, '20ft-open-side': 3404, '20ft-side-door': 2700, '20ft-used': 1050, '40ft-hc-one-trip': 2841, '40ft-hc-double-door': 3174, '40ft-hc-open-side': null, '40ft-hc-side-door': 5600, '40ft-hc-used': 1550, '40ft-std-used': null },
    "Jacksonville, FL":   { '20ft-one-trip': 2300, '20ft-open-side': 4600, '20ft-side-door': null, '20ft-used': 1400, '40ft-hc-one-trip': 2950, '40ft-hc-double-door': 4000, '40ft-hc-open-side': null, '40ft-hc-side-door': 5550, '40ft-hc-used': 2128, '40ft-std-used': 1550 },
    "Tampa, FL":          { '20ft-one-trip': 2139, '20ft-open-side': null, '20ft-side-door': null, '20ft-used': 1545, '40ft-hc-one-trip': 3094, '40ft-hc-double-door': null, '40ft-hc-open-side': null, '40ft-hc-side-door': 6700, '40ft-hc-used': 1653, '40ft-std-used': 1750 },
    "Miami, FL":          { '20ft-one-trip': 1903, '20ft-open-side': 4400, '20ft-side-door': null, '20ft-used': 1030, '40ft-hc-one-trip': 2678, '40ft-hc-double-door': 3333, '40ft-hc-open-side': 10200, '40ft-hc-side-door': 6040, '40ft-hc-used': 1725, '40ft-std-used': null },
    "Savannah, GA":       { '20ft-one-trip': 1789, '20ft-open-side': 4360, '20ft-side-door': 2800, '20ft-used': 979, '40ft-hc-one-trip': 2750, '40ft-hc-double-door': 3223, '40ft-hc-open-side': null, '40ft-hc-side-door': 5137, '40ft-hc-used': 1320, '40ft-std-used': 1100 },
    "Charleston, SC":     { '20ft-one-trip': 1954, '20ft-open-side': null, '20ft-side-door': 2900, '20ft-used': 966, '40ft-hc-one-trip': 2900, '40ft-hc-double-door': 3375, '40ft-hc-open-side': null, '40ft-hc-side-door': 5191, '40ft-hc-used': 1291, '40ft-std-used': 1378 },
    "Charlotte, NC":      { '20ft-one-trip': 2360, '20ft-open-side': 5500, '20ft-side-door': null, '20ft-used': 1650, '40ft-hc-one-trip': 3300, '40ft-hc-double-door': null, '40ft-hc-open-side': null, '40ft-hc-side-door': 6041, '40ft-hc-used': 1984, '40ft-std-used': null },
    "Norfolk, VA":        { '20ft-one-trip': 1963, '20ft-open-side': 4300, '20ft-side-door': null, '20ft-used': 1000, '40ft-hc-one-trip': 2625, '40ft-hc-double-door': 3300, '40ft-hc-open-side': null, '40ft-hc-side-door': 5990, '40ft-hc-used': 1578, '40ft-std-used': null },
    "Baltimore, MD":      { '20ft-one-trip': 1961, '20ft-open-side': 5000, '20ft-side-door': null, '20ft-used': 1227, '40ft-hc-one-trip': 2550, '40ft-hc-double-door': 3540, '40ft-hc-open-side': null, '40ft-hc-side-door': 6235, '40ft-hc-used': 1391, '40ft-std-used': 1250 },
    "Wilmington, DE":     { '20ft-one-trip': 2500, '20ft-open-side': null, '20ft-side-door': null, '20ft-used': null, '40ft-hc-one-trip': null, '40ft-hc-double-door': null, '40ft-hc-open-side': null, '40ft-hc-side-door': null, '40ft-hc-used': null, '40ft-std-used': null },
    "New York, NY":       { '20ft-one-trip': 1745, '20ft-open-side': 4657, '20ft-side-door': 3000, '20ft-used': 966, '40ft-hc-one-trip': 2500, '40ft-hc-double-door': 3138, '40ft-hc-open-side': 9300, '40ft-hc-side-door': 5550, '40ft-hc-used': 1200, '40ft-std-used': null },
    "Boston, MA":         { '20ft-one-trip': 2321, '20ft-open-side': 5200, '20ft-side-door': null, '20ft-used': 1850, '40ft-hc-one-trip': 3165, '40ft-hc-double-door': 3807, '40ft-hc-open-side': null, '40ft-hc-side-door': 6850, '40ft-hc-used': 1885, '40ft-std-used': 1800 }
  };

  // Product display names (for homepage dropdown)
  var PRODUCT_LABELS = {
    '20ft-one-trip':       "20' Standard One Trip",
    '20ft-open-side':      "20' Open Side",
    '20ft-side-door':      "20' Side Door",
    '20ft-used':           "20' Cargo Worthy (Used)",
    '40ft-hc-one-trip':    "40' HC One Trip",
    '40ft-hc-double-door': "40' HC Double Door",
    '40ft-hc-open-side':   "40' HC Open Side",
    '40ft-hc-side-door':   "40' HC Side Door",
    '40ft-hc-used':        "40' HC Cargo Worthy (Used)",
    '40ft-std-used':       "40' Standard Cargo Worthy (Used)"
  };

  // Margin rules: margin = max(min, wholesaleCost * pct)
  var PRODUCT_MARGINS = {
    '20ft-one-trip':       { min: 775,  pct: 0.23 },
    '20ft-open-side':      { min: 825,  pct: 0.23 },
    '20ft-side-door':      { min: 825,  pct: 0.23 },
    '20ft-used':           { min: 625,  pct: 0.23 },
    '40ft-hc-one-trip':    { min: 825,  pct: 0.23 },
    '40ft-hc-double-door': { min: 920,  pct: 0.23 },
    '40ft-hc-open-side':   { min: 920,  pct: 0.23 },
    '40ft-hc-side-door':   { min: 920,  pct: 0.23 },
    '40ft-hc-used':        { min: 650,  pct: 0.23 },
    '40ft-std-used':       { min: 650,  pct: 0.23 }
  };

  // Depot network with delivery rates
  // CORRECTED: min = flat rate for deliveries ≤100 miles, rate = $/mile for overage beyond 100mi
  var DEPOTS = [
    { name: "Los Angeles, CA",    city: "Los Angeles, CA",       min: 500, rate: 5.00 },
    { name: "Oakland, CA",        city: "Oakland, CA",           min: 600, rate: 6.00 },
    { name: "Seattle/Tacoma",     city: "Seattle, WA",           min: 600, rate: 5.50, special: 'seattle' },
    { name: "Portland, OR",       city: "Portland, OR",          min: 600, rate: 6.00 },
    { name: "Phoenix, AZ",        city: "Phoenix, AZ",           min: 600, rate: 7.00 },
    { name: "El Paso, TX",        city: "El Paso, TX",           min: 550, rate: 5.50 },
    { name: "San Antonio, TX",    city: "San Antonio, TX",       min: 550, rate: 5.50 },
    { name: "Denver, CO",         city: "Denver, CO",            min: 600, rate: 6.00 },
    { name: "Salt Lake City, UT", city: "Salt Lake City, UT",    min: 550, rate: 5.50 },
    { name: "Kansas City, MO",    city: "Kansas City, MO",       min: 525, rate: 5.25 },
    { name: "Saint Louis, MO",    city: "Saint Louis, MO",       min: 525, rate: 5.25 },
    { name: "Chicago, IL",        city: "Chicago, IL",           min: 550, rate: 5.50 },
    { name: "Minneapolis, MN",    city: "Minneapolis, MN",       min: 550, rate: 5.50 },
    { name: "Indianapolis, IN",   city: "Indianapolis, IN",      min: 550, rate: 5.50 },
    { name: "Omaha, NE",          city: "Omaha, NE",             min: 550, rate: 5.50 },
    { name: "Dallas, TX",         city: "Dallas, TX",            min: 450, rate: 4.50 },
    { name: "Houston, TX",        city: "Houston, TX",           min: 450, rate: 4.50 },
    { name: "New Orleans, LA",    city: "New Orleans, LA",       min: 450, rate: 4.50 },
    { name: "Mobile, AL",         city: "Mobile, AL",            min: 450, rate: 4.50 },
    { name: "Memphis, TN",        city: "Memphis, TN",           min: 500, rate: 5.00 },
    { name: "Nashville, TN",      city: "Nashville, TN",         min: 500, rate: 5.00 },
    { name: "Atlanta, GA",        city: "Atlanta, GA",           min: 500, rate: 5.00 },
    { name: "Louisville, KY",     city: "Louisville, KY",        min: 600, rate: 6.00 },
    { name: "Cincinnati, OH",     city: "Cincinnati, OH",        min: 600, rate: 6.00 },
    { name: "Columbus, OH",       city: "Columbus, OH",          min: 550, rate: 5.50 },
    { name: "Cleveland, OH",      city: "Cleveland, OH",         min: 575, rate: 5.75 },
    { name: "Detroit, MI",        city: "Detroit, MI",           min: 550, rate: 5.50 },
    { name: "Jacksonville, FL",   city: "Jacksonville, FL",      min: 500, rate: 5.00 },
    { name: "Tampa, FL",          city: "Tampa, FL",             min: 500, rate: 5.00 },
    { name: "Miami, FL",          city: "Miami, FL",             min: 550, rate: 5.50 },
    { name: "Savannah, GA",       city: "Savannah, GA",          min: 500, rate: 5.00 },
    { name: "Charleston, SC",     city: "Charleston, SC",        min: 525, rate: 5.25 },
    { name: "Charlotte, NC",      city: "Charlotte, NC",         min: 550, rate: 5.50 },
    { name: "Norfolk, VA",        city: "Norfolk, VA 23510",     min: 600, rate: 6.00 },
    { name: "Baltimore, MD",      city: "Baltimore, MD",         min: 600, rate: 6.00 },
    { name: "Wilmington, DE",     city: "Wilmington, DE",        min: 550, rate: 5.50 },
    { name: "New York, NY",       city: "New York, NY",          min: 550, rate: 5.50 },
    { name: "Boston, MA",         city: "Boston, MA",            min: 550, rate: 5.50 }
  ];

  // ============================================================
  // CORE PRICING FUNCTIONS
  // ============================================================

  function calcMargin(productKey, wholesaleCost) {
    var m = PRODUCT_MARGINS[productKey] || { min: 0, pct: 0.23 };
    return Math.max(m.min, Math.round(wholesaleCost * m.pct));
  }

  // CORRECTED delivery model: flat min for ≤100mi, then min + overage beyond 100mi
  function calcDelivery(depot, miles) {
    if (depot.special === 'seattle') {
      if (miles <= 30) return 400;
      return 400 + (miles - 30) * 5.50;
    }
    if (miles <= 100) return depot.min;
    return depot.min + (miles - 100) * depot.rate;
  }

  // Get the "Starting at" price — lowest possible delivered price across all depots (local delivery)
  function getStartingAt(productKey) {
    if (!productKey) return null;
    var best = Infinity;
    DEPOTS.forEach(function (depot) {
      var prices = PRODUCT_PRICES[depot.name];
      if (!prices) return;
      var wholesale = prices[productKey];
      if (wholesale === null || wholesale === undefined) return;
      var margin = calcMargin(productKey, wholesale);
      var total = wholesale + margin + depot.min; // min delivery = local
      if (total < best) best = total;
    });
    return best === Infinity ? null : best;
  }

  function fmt(n) {
    return n.toLocaleString('en-US', {
      style: 'currency', currency: 'USD',
      minimumFractionDigits: 0, maximumFractionDigits: 0
    });
  }

  // ============================================================
  // GOOGLE MAPS INTEGRATION
  // ============================================================

  var _mapsReady = false;
  var _mapsCallbacks = [];

  function loadMaps(cb) {
    if (_mapsReady) { cb(); return; }
    _mapsCallbacks.push(cb);
    if (window.__primeShippingMapsLoading) return;
    window.__primeShippingMapsLoading = true;
    window.__primeShippingMapsReady = function () {
      _mapsReady = true;
      _mapsCallbacks.forEach(function (fn) { fn(); });
      _mapsCallbacks = [];
    };
    var s = document.createElement('script');
    s.src = 'https://maps.googleapis.com/maps/api/js?key=' +
      encodeURIComponent(MAPS_API_KEY) + '&callback=__primeShippingMapsReady';
    s.async = true; s.defer = true;
    s.onerror = function () {
      _mapsCallbacks.forEach(function (fn) { fn(new Error('maps_load_failed')); });
      _mapsCallbacks = [];
    };
    document.head.appendChild(s);
  }

  // Main calculation: find best depot for a given ZIP + product
  // Calls back with: callback(error, result)
  // result = { total, consumerPrice, delivery, depot, miles } or null
  function calculatePrice(zip, productKey, callback) {
    loadMaps(function (err) {
      if (err) { callback(err); return; }

      var service = new google.maps.DistanceMatrixService();
      var distances = new Array(DEPOTS.length).fill(null);
      var batch1 = DEPOTS.slice(0, 25).map(function (d) { return d.city; });
      var batch2 = DEPOTS.slice(25).map(function (d) { return d.city; });
      var remaining = batch2.length > 0 ? 2 : 1;
      var hasError = false;

      function onBatch(resp, status, startIdx) {
        if (status !== 'OK') {
          if (!hasError) { hasError = true; callback(new Error('distance_failed')); }
          return;
        }
        resp.rows.forEach(function (row, i) {
          var el = row.elements[0];
          if (el && el.status === 'OK') {
            distances[startIdx + i] = el.distance.value / 1609.344; // meters to miles
          }
        });
        remaining--;
        if (remaining === 0) findBest();
      }

      var opts = {
        destinations: [zip + ', USA'],
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.IMPERIAL
      };

      service.getDistanceMatrix(
        Object.assign({}, opts, { origins: batch1 }),
        function (r, s) { onBatch(r, s, 0); }
      );
      if (batch2.length > 0) {
        service.getDistanceMatrix(
          Object.assign({}, opts, { origins: batch2 }),
          function (r, s) { onBatch(r, s, 25); }
        );
      }

      // IMPROVED: Compare ALL depots to find true global minimum (not just 2 nearest)
      function findBest() {
        var candidates = [];
        distances.forEach(function (miles, i) {
          if (miles === null) return;
          var depot = DEPOTS[i];
          var prices = PRODUCT_PRICES[depot.name];
          if (!prices) return;
          var wholesale = prices[productKey];
          if (wholesale === null || wholesale === undefined) return;

          var margin = calcMargin(productKey, wholesale);
          var consumerPrice = wholesale + margin;
          var delivery = calcDelivery(depot, miles);
          var total = consumerPrice + delivery;

          candidates.push({
            depot: depot, miles: miles, delivery: delivery,
            wholesale: wholesale, consumerPrice: consumerPrice, total: total
          });
        });

        if (candidates.length === 0) {
          // No depot has this product — show delivery-only estimate from nearest depot
          var nearest = distances
            .map(function (m, i) { return { miles: m, depot: DEPOTS[i] }; })
            .filter(function (d) { return d.miles !== null; })
            .sort(function (a, b) { return a.miles - b.miles; })[0];

          if (!nearest) { callback(new Error('no_route')); return; }
          callback(null, {
            deliveryOnly: true,
            delivery: calcDelivery(nearest.depot, nearest.miles),
            depot: nearest.depot,
            miles: nearest.miles
          });
          return;
        }

        // Find the absolute cheapest total delivered price across ALL depots
        candidates.sort(function (a, b) { return a.total - b.total; });
        callback(null, candidates[0]);
      }
    });
  }

  // ============================================================
  // PUBLIC API
  // ============================================================

  return {
    PRODUCT_PRICES: PRODUCT_PRICES,
    PRODUCT_LABELS: PRODUCT_LABELS,
    PRODUCT_MARGINS: PRODUCT_MARGINS,
    DEPOTS: DEPOTS,
    calcMargin: calcMargin,
    calcDelivery: calcDelivery,
    getStartingAt: getStartingAt,
    calculatePrice: calculatePrice,
    fmt: fmt
  };

})();
